import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 按照POL,POD查询IATAPrice
export function queryIataPrice(params) {
  return request({
    url: URL.price.iataPrice.queryIataPrice,
    method: 'get',
    params
  })
}

export function queryIataPriceCarrier(params) {
  return request({
    url: URL.price.iataPrice.queryIataPriceCarrier,
    method: 'get',
    params
  })
}

// 保存IATA运价
export function saveIataPrice(data) {
  return request({
    url: URL.price.iataPrice.saveIataPrice,
    method: 'post',
    data
  })
}

// 删除IATA运价
export function deleteIataPrice(params) {
  return request({
    url: URL.price.iataPrice.deleteIataPrice,
    method: 'delete',
    params
  })
}
